import * as z from 'zod';

export const courierOrdersSearchSchema = z.object({
  orderStatus: z
    .enum(['active', 'cancelled', 'finished', 'returned', 're-offered'])
    .default('finished'),
  orderPage: z.coerce.number().int().positive().catch(1).default(1),
  orderPageSize: z.coerce.number().int().min(1).max(100).catch(10).default(10),
  orderFrom: z.iso.date().optional().catch(undefined),
  orderTill: z.iso.date().optional().catch(undefined),
});

export type CourierOrdersSearch = z.infer<typeof courierOrdersSearchSchema>;
